function runPo2go(){
  var store_config = {
    "punchout_only":0,
    "transfer_label":"Transfer Cart",
    "custom_style":"body.punchout .additional-checkout-buttons {display:none} body.punchout .eq-email-wrapper {display:none} .shopify-payment-button {display:none} .punchout button[name=\"checkout\"] {display:none}",
    "checkout_selector":"button[name=\"checkout\"]",
    "transfer_selector":"button[name=\"transfer_items\"]",
    "transfer_btn_html":"<button type=\"submit\" name=\"transfer_items\" class=\"btn\" onClick=\"POSession.extension.transferCart(); return false;\" >Transfer Cart</button>",
    "return_selector":"ul .site-nav",
    "return_btn_html":"<li type=\"submit\" name=\"close_punchout\" class=\"btn return_btn site-nav\" onClick=\"POSession.cancel();\" >Close PunchOut<\/li>",
};
   
    POExt = new Po2go_Shopify(store_config);     
    POSession = new Po2go({
        'account':'',
        'punchout_only' : store_config.punchout_only,
        'extension' : POExt
    });
    POSession.init();
    POSession.extension.setupPage();
//    POSession.extension.returnToProcButton(); // Add this if you need to add a Close PunchOut button; don't forget to add your return_selector and return_btn_html to the store_config
}